/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recurringdateslabel2Inputs */

const en_recurringdateslabel2 = /** @type {(inputs: Recurringdateslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dates`)
};

const de_recurringdateslabel2 = /** @type {(inputs: Recurringdateslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine`)
};

/**
* | output |
* | --- |
* | "Dates" |
*
* @param {Recurringdateslabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const recurringdateslabel2 = /** @type {((inputs?: Recurringdateslabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurringdateslabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurringdateslabel2(inputs)
	return de_recurringdateslabel2(inputs)
});
export { recurringdateslabel2 as "recurringDatesLabel" }